export enum TOAST_EVENTS {
	SHOW_ADD_ITEM_TOAST = "SHOW_ADD_ITEM_TOAST",
	SHOW_REMOVE_ITEM_TOAST = "SHOW_REMOVE_ITEM_TOAST",
}
